import { render, staticRenderFns } from "./TransferenciaPosse.vue?vue&type=template&id=532c4aa8&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/transferencia-posse/TransferenciaPosse.vue
// module id = 1560
// module chunks = 28